import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import WithdrawContent from './WithdrawContent';

export default function PaymentWithdrawal() {
  return (
    <CasinoContainer title={'Withdrawal limits'}>
      <WithdrawContent />
    </CasinoContainer>
  );
}
